import React from 'react';
import Maintenance from "@components/views/Maintenance/Main";

const MaintenanceContainer = (props) => {
    return (
        <Maintenance/>
    );
}

export default MaintenanceContainer;